import { render, staticRenderFns } from "./MRUploading.vue?vue&type=template&id=45bd6004&scoped=true&"
import script from "./MRUploading.vue?vue&type=script&lang=js&"
export * from "./MRUploading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bd6004",
  null
  
)

export default component.exports